import { ENTITY_TYPE } from 'consts/flows';
import { isDev } from 'helpers';
import { AppContext } from 'providers/AppContext';
import { useContext, useMemo } from 'react';
import { LANGUAGES } from 'store/state';
import useSWR from 'swr';

export function useAml() {
	const ctx = useContext(AppContext);
	const { config, entityType, flowType, state, fetchRelations, goToNextPage, navigate } = ctx;
	const { context, language, user } = state;
	const showBTN = config.IS_EMPLOYEE_WEB || isDev(config.APP_ENV);
	const baseURL = config.API.getAMLQuestions;
	const lang = LANGUAGES.indexOf(language.language);
	const kt = context.kennitala || user.kennitala;
	const getQuestionnaireUrl = `${baseURL}/${kt}?amlLanguageCode=${lang}`;
	const { data, isLoading } = useSWR(getQuestionnaireUrl);

	const requestConfig = useMemo(
		() => ({
			baseURL,
			headers: { Authorization: `Bearer ${user.token}` },
			method: 'GET' as const
		}),
		[baseURL, user.token]
	);

	const onFinish = () => {
		if (ENTITY_TYPE.INDIVIDUAL === entityType) {
			navigate(`/${flowType}/${entityType}/onboard`);
		} else {
			fetchRelations(true);
		}
	};

	const skip = () => {
		if (ENTITY_TYPE.INDIVIDUAL === entityType) {
			navigate(`/${flowType}/${entityType}/onboard`);
		} else {
			goToNextPage();
		}
	};

	return {
		...ctx,
		data,
		getQuestionnaireUrl,
		isLoading,
		onFinish,
		requestConfig,
		showBTN,
		skip
	};
}
